<script setup lang="ts">
import type { SUPPORTED_PAGES } from "~/types/breadcrumb"

/**
 *
 *  Props and emits section
 *
 *
 */

defineProps<{
    menuItems: {
        route: string
        name: string
        page: SUPPORTED_PAGES
        isHidden?: boolean
    }[]
    primaryButton?: boolean
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const route = useRoute()
const router = useRouter()
const { $bus } = useNuxtApp()

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

function goTo(toRoute: string) {
    if (toRoute == "/store" && route.name == "store") {
        ($bus as any).$emit("refresh:store-view")
    } else {
        router.push(toRoute)
    }
}
</script>

<template>
    <div class="tw-flex tw-flex-1 tw-w-full tw-items-center tw-gap-5 xl:tw-gap-10 tw-ml-2">
        <template v-for="(menuItem, i) in menuItems" :key="i">
            <NuxtLink v-if="!menuItem.isHidden" @click="goTo(menuItem.route)"
                :class="`${primaryButton && (menuItem.page === SUPPORTED_PAGES_ENUM.Store) ? 'tw-bg-secondary tw-rounded-full tw-px-7 tw-py-2 tw-text-white' : '!tw-p-0'} tw-flex tw-items-center tw-text-sm lg:tw-text-base tw-w-max tw-text-gray-500 hover:tw-text-primary tw-font-bold tw-cursor-pointer`">
                {{ menuItem.name }}</NuxtLink>
        </template>
    </div>
</template>

<style scoped></style>
